import { useState, useCallback } from 'react';

export const useMessageState = (onSendMessage: (message: string) => void) => {
  const [message, setMessage] = useState('');

  const handleSendMessage = useCallback(() => {
    if (message.trim()) {
      onSendMessage(message.trim());
      setMessage('');
    }
  }, [message, onSendMessage]);

  const handleSuggestedAction = useCallback((action: string) => {
    setMessage(action);
  }, []);

  return {
    message,
    setMessage,
    handleSendMessage,
    handleSuggestedAction
  };
};
